module.exports = __webpack_public_path__ + "static/img/cara-nezumi.0f682d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cara-nezumi.svg
// module id = 842r
// module chunks = 1